import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { Button } from './components/Button';
import { SocialProofPopup } from './components/SocialProofPopup';
import { PlanCard } from './components/PlanCard';
import { IndividualProductCard } from './components/IndividualProductCard';
import { TestimonialCard } from './components/TestimonialCard';
import { FAQItem } from './components/FAQItem';
// Meta Pixel Types
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const FadeIn = ({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-50px'
}} transition={{
  duration: 0.5,
  delay
}} data-id="element-0">
    {children}
  </motion.div>;
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel
    if (typeof window !== 'undefined' && !window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        document.head.appendChild(t);
      }
      window.fbq('init', '790333870788238');
      window.fbq('track', 'PageView');
    }
  }, []);
  const scrollToCompra = () => {
    const element = document.getElementById('compra');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-white font-sans text-brand-navy selection:bg-brand-pink selection:text-white pb-20" data-id="element-1">
      <SocialProofPopup data-id="element-2" />

      {/* TOP ANNOUNCEMENT BAR */}
      <div className="bg-brand-red text-white text-center py-2 px-4 text-sm font-medium w-full" data-id="element-3">
        ENGLISH FOR SPECIFIC PURPOSES & TECHNICAL ENGLISH accedo inmediato
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 pt-4" data-id="element-4">
        {/* 1. HERO SECTION */}
        <section className="text-center mb-12" data-id="element-5">
          <FadeIn data-id="element-6">
            <p className="text-brand-gray sm:text-base mb-2 font-medium text-[12px]" data-id="element-7">
              Recursos listos para usar para docentes de inglés
            </p>
            <h1 className="sm:text-4xl md:text-5xl font-black text-brand-pink mb-4 text-[24px]" data-id="element-8">
              MEGAPACK TEACHER RESOURCE
            </h1>
            <h2 className="sm:text-2xl font-bold text-brand-navy mb-8 text-[18px]" data-id="element-9">
              Deja de perder horas creando material para inglés profesional y
              técnico.
            </h2>

            <div className="relative max-w-md mx-auto mb-8" data-id="element-10">
              <img src="https://cdn.magicpatterns.com/uploads/13nfcc4ji7mBcmKy85QbL1/imagen_hero_principal.png" alt="Megapack Teacher Resource - English for Specific Purposes & Technical English" className="w-full" data-id="element-11" />
            </div>

            <p className="text-base sm:text-lg text-brand-navy mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-12">
              Todo organizado, listo para usar y adaptado a contextos reales de
              trabajo y formación técnica.
            </p>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto mb-10 text-left" data-id="element-13">
              <h3 className="font-bold text-lg sm:text-xl mb-6 text-center text-brand-navy" data-id="element-14">
                👉 Acceso inmediato y organizado
              </h3>
              <ul className="space-y-4" data-id="element-15">
                {['Compras ahora', 'Recibes acceso automático', 'Accedes al material organizado', 'Descargas todo al instante', 'Acceso de por vida'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-bold text-base sm:text-lg" data-id="element-16">
                    <span className="mr-3 text-xl text-green-500" data-id="element-17">✔</span>
                    {item}
                  </li>)}
              </ul>
            </div>

            <Button onClick={scrollToCompra} data-id="element-18">👉 ACCEDER AHORA</Button>
          </FadeIn>
        </section>

        {/* 2. PREGUNTA BLOCK */}
        <section className="text-center mb-12" data-id="element-19">
          <FadeIn data-id="element-20">
            <p className="text-lg mb-4 font-[600] text-brand-pink" data-id="element-21">
              Si eres docente de inglés, déjame hacerte una pregunta honesta:
            </p>
            <h2 className="sm:text-3xl font-bold mb-6 text-[20px] text-brand-red" data-id="element-22">
              ¿Alguna vez necesitaste preparar una clase de Business English,
              Tourism English o Technical English y terminaste buscando material
              durante horas?
            </h2>
            <div className="space-y-4 text-base sm:text-lg text-brand-navy max-w-2xl mx-auto" data-id="element-23">
              <p data-id="element-24">
                Porque encontrar recursos de inglés especializado no es fácil.
              </p>
              <p data-id="element-25">
                Y cuando encuentras algo, muchas veces no está listo para usar
                directamente en clase.
              </p>
              <p data-id="element-26">
                Por eso muchos docentes terminan adaptando textos, creando
                actividades y preparando material desde cero.
              </p>
              <p className="font-bold text-xl mt-6" data-id="element-27">
                Dar clases de inglés especializado no debería ser tan difícil.
              </p>
            </div>
          </FadeIn>
        </section>

        {/* 3. PROBLEMA BLOCK */}
        <section className="text-center mb-12" data-id="element-28">
          <FadeIn data-id="element-29">
            <h2 className="text-2xl sm:text-3xl font-bold mb-8 text-brand-pink" data-id="element-30">
              El problema que muchos docentes viven todos los días:
            </h2>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto mb-8 text-left" data-id="element-31">
              <ul className="space-y-4" data-id="element-32">
                {['Pasan horas buscando material específico', 'Adaptan recursos que no fueron pensados para sus alumnos', 'Crean actividades desde cero', 'Improvisan clases a último momento', 'Terminan utilizando siempre los mismos recursos'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium text-base sm:text-lg" data-id="element-33">
                    <span className="mr-3 text-brand-red font-bold text-xl" data-id="element-34">
                      •
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>

            <p className="text-xl sm:text-2xl font-bold text-brand-navy" data-id="element-35">
              Podrías dar mejores clases si tuvieras todo listo.
            </p>
          </FadeIn>
        </section>

        {/* 4. SOLUCIÓN BLOCK */}
        <section className="text-center mb-12" data-id="element-36">
          <FadeIn data-id="element-37">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-pink mb-6" data-id="element-38">
              La solución: Megapack Teacher Resource
            </h2>

            <p className="text-base sm:text-lg text-brand-navy mb-10 max-w-2xl mx-auto" data-id="element-39">
              Una biblioteca completa de actividades listas para enseñar inglés
              profesional y técnico.
            </p>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-2xl mx-auto mb-10" data-id="element-40">
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-lg font-bold text-brand-navy" data-id="element-41">
                <div className="flex items-center" data-id="element-42">
                  <span className="text-2xl mr-2" data-id="element-43">📂</span> Eliges el área
                </div>
                <span className="hidden sm:inline text-brand-gray" data-id="element-44">➔</span>
                <span className="sm:hidden text-brand-gray" data-id="element-45">⬇</span>
                <div className="flex items-center" data-id="element-46">
                  <span className="text-2xl mr-2" data-id="element-47">📖</span> Descargas las
                  actividades
                </div>
                <span className="hidden sm:inline text-brand-gray" data-id="element-48">➔</span>
                <span className="sm:hidden text-brand-gray" data-id="element-49">⬇</span>
                <div className="flex items-center text-brand-pink" data-id="element-50">
                  <span className="text-2xl mr-2" data-id="element-51">🗣</span> Aplicas la clase
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-8 mb-10 font-bold text-brand-navy text-lg" data-id="element-52">
              <div className="font-[400]" data-id="element-53">
                <span className="text-green-500" data-id="element-54">✔</span> Sin crear material
                desde cero
              </div>
              <div className="font-[400]" data-id="element-55">
                <span className="text-green-500" data-id="element-56">✔</span> Sin perder horas
                buscando recursos
              </div>
              <div className="font-[400]" data-id="element-57">
                <span className="text-green-500" data-id="element-58">✔</span> Sin improvisar
              </div>
            </div>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto text-left" data-id="element-59">
              <ul className="space-y-3" data-id="element-60">
                {['Con material organizado y listo para usar'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium text-base" data-id="element-61">
                      <span className="mr-3 text-green-500 text-lg" data-id="element-62">✔</span>
                      {item}
                    </li>)}
              </ul>
            </div>
          </FadeIn>
        </section>
      </div>

      {/* 5. PRICING SECTION - DARK BG */}
      <section id="compra" className="scroll-mt-10" data-id="element-63">
        <FadeIn data-id="element-64">
          <div className="bg-[#1a2744] py-16 px-4" data-id="element-65">
            <div className="max-w-3xl mx-auto text-center" data-id="element-66">
              <h2 className="text-2xl sm:text-3xl font-bold text-brand-pink mb-10" data-id="element-67">
                Elegí tu Pack
              </h2>

              {/* Three plan cards */}
              <div className="grid md:grid-cols-3 gap-6 lg:gap-5 max-w-5xl mx-auto mb-10 items-stretch" data-id="element-68">
                <PlanCard badge="PACK ESP" title="PACK 1 — ENGLISH FOR SPECIFIC PURPOSES (ESP)" items={['Inglés para Adultos', 'English for Travelers', 'Business English Pack 1', 'Business English Pack 2', 'Tourism & Customer Service English', 'Healthcare English', 'International Trade English']} price="USD 19" buttonText="👉 QUIERO EL PACK ESP" href="https://pay.hotmart.com/M106237367A" image="https://cdn.magicpatterns.com/uploads/x4p9a68MANwJ1j7wE5MyRC/PACK_ESP.png" data-id="element-69" />

                <PlanCard badge="PACK TÉCNICO" title="PACK 2 — TECHNICAL ENGLISH" items={['Technical English for Information Technology', 'Technical English for Automotive Technology', 'Technical English for Industrial Automation', 'Technical English for Agricultural Technology']} price="USD 21" buttonText="👉 QUIERO EL PACK TECHNICAL ENGLISH" href="https://pay.hotmart.com/R106308668P" image="https://cdn.magicpatterns.com/uploads/rPiSBQmJwqxZBXpTMMSH3i/PACK_TECNICO.png" data-id="element-70" />

                <PlanCard badge="MEGAPACK COMPLETO" title="" subtitle="Toda la biblioteca profesional y técnica en un solo lugar" items={['Inglés para Adultos', 'English for Travelers', 'Business English Pack 1', 'Business English Pack 2', 'Tourism & Customer Service English', 'Healthcare English', 'International Trade English', 'Technical English for Information Technology', 'Technical English for Automotive Technology', 'Technical English for Industrial Automation', 'Technical English for Agricultural Technology']} originalPrice="USD 40" price="USD 32" savings="¡Ahorrás USD 8!" buttonText="👉 QUIERO TODO EL MATERIAL" href="https://pay.hotmart.com/R106308712C" featured image="https://cdn.magicpatterns.com/uploads/g6MAjRBAsVs3LJqdcgVpM2/MEGAPACK_COMPLETO.png" data-id="element-71" />
              </div>
            </div>
          </div>
        </FadeIn>
      </section>

      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-72">
        {/* 6. COMPRA INDIVIDUAL */}
        <section className="text-center mb-12 mt-12" data-id="element-73">
          <FadeIn data-id="element-74">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-navy mb-4" data-id="element-75">
              🛒 Compra individual
            </h2>
            <p className="text-base sm:text-lg text-brand-navy mb-10 max-w-2xl mx-auto" data-id="element-76">
              ¿Necesitas solamente un área específica? También puedes comprar
              cada recurso por separado.
            </p>

            <div className="grid sm:grid-cols-2 gap-6" data-id="element-77">
              <IndividualProductCard title="Inglés para Adultos" description="Actividades diseñadas para enseñar inglés básico e intermedio a estudiantes adultos. Situaciones cotidianas, comunicación práctica y recursos listos para aplicar en clase." price="USD 12" href="https://pay.hotmart.com/G106309280D" image="https://cdn.magicpatterns.com/uploads/3tY9i3ELdTdbqq5A5cEc8i/INGLES_PARA_ADULTOS.png" data-id="element-78" />
              <IndividualProductCard title="English for Travelers" description="Material enfocado en situaciones reales de viaje. Aeropuertos, hoteles, transporte, restaurantes, turismo y comunicación internacional." price="USD 12" href="https://pay.hotmart.com/O106309420B" image="https://cdn.magicpatterns.com/uploads/wHMraZYGgZTkLcjd2SsE2j/English_for_Travelers.png" data-id="element-79" />
              <IndividualProductCard title="Business English Pack 1 y 2" description="Actividades listas para trabajar la comunicación profesional en empresas y organizaciones. Incluye vocabulario de negocios, reuniones, presentaciones, correos electrónicos y situaciones laborales reales." price="USD 12" href="https://pay.hotmart.com/D106308945U" image="https://cdn.magicpatterns.com/uploads/7TKkxHCNV1ahVTebLZHkpf/Business_English_Pack.png" data-id="element-80" />
              <IndividualProductCard title="Tourism & Customer Service English" description="Recursos listos para enseñar inglés aplicado al turismo, hotelería y atención al cliente. Ideal para desarrollar habilidades de comunicación en situaciones reales de servicio." price="USD 12" href="https://pay.hotmart.com/B106308994U" image="https://cdn.magicpatterns.com/uploads/17SapxkcSUzZBMsSe3HrGq/Tourism__Customer_Service_English_Pack.png" data-id="element-81" />
              <IndividualProductCard title="Healthcare English" description="Material diseñado para trabajar vocabulario y comunicación en entornos de salud. Incluye actividades relacionadas con pacientes, consultas, hospitales y situaciones profesionales frecuentes." price="USD 12" href="https://pay.hotmart.com/L106309016W" image="https://cdn.magicpatterns.com/uploads/jHfiignAa8oGthPvHE54v6/Healthcare_English_Pack.png" data-id="element-82" />
              <IndividualProductCard title="International Trade English" description="Actividades enfocadas en comercio internacional, importaciones, exportaciones, logística y comunicación empresarial global. Ideal para estudiantes y profesionales del sector." price="USD 12" href="https://pay.hotmart.com/J106309041M" image="https://cdn.magicpatterns.com/uploads/efyECz9g4a2z8X5dMWBeuf/International_Trade_English.png" data-id="element-83" />
              <IndividualProductCard title="Technical English for Information Technology" description="Inglés técnico aplicado al mundo de la informática. Incluye hardware, software, sistemas operativos, redes, mantenimiento, seguridad informática y vocabulario tecnológico actual." price="USD 12" href="https://pay.hotmart.com/P106309106T" image="https://cdn.magicpatterns.com/uploads/fhB1UtSZyKb47PDFH55HMo/Technical_English_for_Information_Technology.png" data-id="element-84" />
              <IndividualProductCard title="Technical English for Automotive Technology" description="Material orientado al sector automotriz. Trabaja vocabulario relacionado con vehículos, motores, sistemas mecánicos, mantenimiento y tecnología aplicada a la industria automotriz." price="USD 12" href="https://pay.hotmart.com/S106309142N" image="https://cdn.magicpatterns.com/uploads/7Dzo5u5MXo148HnwGAHt45/Technical_English_for_Automotive_Technology.png" data-id="element-85" />
              <IndividualProductCard title="Technical English for Industrial Automation" description="Actividades diseñadas para enseñar inglés técnico en automatización industrial. Incluye procesos productivos, control industrial, sensores, robótica y tecnología aplicada." price="USD 12" href="https://pay.hotmart.com/P106238496F" image="https://cdn.magicpatterns.com/uploads/hBVw4R1JCEtB7eMhrNQJqJ/Technical_English_for_Industrial_Automation.png" data-id="element-86" />
              <IndividualProductCard title="Technical English for Agricultural Technology" description="Recursos enfocados en el sector agropecuario y la tecnología aplicada al campo. Incluye maquinaria agrícola, producción, sostenibilidad, recursos naturales y procesos agroindustriales." price="USD 12" href="https://pay.hotmart.com/J106238009V" image="https://cdn.magicpatterns.com/uploads/8U2zT3ZYtRUFjB6MaTKDBq/Technical_English_for_Agricultural_Technology.png" data-id="element-87" />
            </div>
          </FadeIn>
        </section>

        {/* 7. QUÉ OBTIENES */}
        <section className="text-center mb-12" data-id="element-88">
          <FadeIn data-id="element-89">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-navy mb-8" data-id="element-90">
              ¿Qué obtienes como docente?
            </h2>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto text-left" data-id="element-91">
              <ul className="space-y-3" data-id="element-92">
                {['Actividades listas para usar', 'Material organizado por especialidad', 'Recursos difíciles de encontrar en un solo lugar', 'Menos tiempo preparando clases', 'Más tiempo enseñando', 'Actividades aplicables a contextos reales', 'Acceso inmediato', 'Descarga digital'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-93">
                    <span className="mr-3 text-green-500 text-lg" data-id="element-94">✔</span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </section>

        {/* 8. MUY IMPORTANTE */}
        <section className="mb-12" data-id="element-95">
          <FadeIn data-id="element-96">
            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto" data-id="element-97">
              <h3 className="text-xl font-bold text-brand-pink mb-4 text-center" data-id="element-98">
                ⚠️ MUY IMPORTANTE
              </h3>
              <p className="text-brand-navy font-bold text-lg text-center mb-4" data-id="element-99">
                Esto no es un curso.
              </p>
              <p className="text-brand-navy font-bold text-lg text-center mb-4" data-id="element-100">
                Esto no es un ebook para leer.
              </p>
              <p className="text-brand-navy text-center mb-6" data-id="element-101">
                Es una colección de recursos educativos diseñada para docentes
                de inglés.
              </p>
              <div className="space-y-2 mb-6" data-id="element-102">
                <p className="text-brand-navy font-bold text-base" data-id="element-103">
                  👉 No vienes a estudiar.
                </p>
                <p className="text-brand-navy font-bold text-base" data-id="element-104">
                  👉 Vienes a resolver tus clases.
                </p>
              </div>
              <ul className="space-y-3" data-id="element-105">
                {['Actividades listas para usar', 'Material organizado', 'Recursos prácticos', 'Aplicación inmediata en el aula'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-106">
                    <span className="mr-3 text-green-500 text-lg" data-id="element-107">✔</span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </section>

        {/* 9. FLEXIBILIDAD */}
        <section className="mb-12" data-id="element-108">
          <FadeIn data-id="element-109">
            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto" data-id="element-110">
              <h3 className="text-xl font-bold text-brand-pink mb-4 text-center" data-id="element-111">
                FLEXIBILIDAD TOTAL
              </h3>
              <p className="text-brand-navy text-center mb-6" data-id="element-112">
                Puedes utilizar el contenido como quieras:
              </p>
              <ul className="space-y-3 mb-6" data-id="element-113">
                {['Imprimirlo', 'Utilizarlo en pantalla', 'Adaptarlo a tus clases', 'Combinar actividades', 'Reutilizarlo las veces que necesites'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-114">
                    <span className="mr-3 text-green-500 text-lg" data-id="element-115">✔</span>
                    {item}
                  </li>)}
              </ul>
              <p className="text-brand-navy font-bold text-center text-lg" data-id="element-116">
                👉 No hay límites. El material es tuyo.
              </p>
            </div>
          </FadeIn>
        </section>

        {/* 10. ACCESO DE POR VIDA */}
        <section className="mb-12" data-id="element-117">
          <FadeIn data-id="element-118">
            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto" data-id="element-119">
              <h3 className="text-xl font-bold text-brand-pink mb-4 text-center" data-id="element-120">
                ACCESO DE POR VIDA
              </h3>
              <p className="text-brand-navy text-center mb-2 font-medium" data-id="element-121">
                Esto es importante:
              </p>
              <p className="text-brand-navy font-bold text-center text-lg mb-6" data-id="element-122">
                Tu acceso es de por vida.
              </p>
              <ul className="space-y-3 mb-6" data-id="element-123">
                {['Descarga inmediata', 'Acceso permanente', 'Uso ilimitado', 'Consúltalo cuando quieras'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-124">
                    <span className="mr-3 text-green-500 text-lg" data-id="element-125">✔</span>
                    {item}
                  </li>)}
              </ul>
              <p className="text-brand-navy font-bold text-center text-lg" data-id="element-126">
                Una sola compra.
              </p>
              <p className="text-brand-navy font-bold text-center text-lg" data-id="element-127">
                Acceso para siempre.
              </p>
            </div>
          </FadeIn>
        </section>

        {/* 11. TESTIMONIALS */}
        <section className="text-center mb-12" data-id="element-128">
          <FadeIn data-id="element-129">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-navy mb-8" data-id="element-130">
              💬 Lo que dicen docentes de distintos países
            </h2>

            <div className="space-y-6 max-w-2xl mx-auto" data-id="element-131">
              <TestimonialCard quote="Lo compré para mis clases de Business English y me ahorró muchísimo tiempo. Las actividades están listas para usar y mis estudiantes respondieron muy bien." country="México" data-id="element-132" />
              <TestimonialCard quote="Las actividades de Tourism & Customer Service fueron exactamente lo que necesitaba. Todo está organizado y es fácil de aplicar." country="Perú" data-id="element-133" />
              <TestimonialCard quote="Encontré recursos de inglés técnico que normalmente son difíciles de conseguir. Muy útil para trabajar con estudiantes de informática." country="Colombia" data-id="element-134" />
              <TestimonialCard quote="Lo que más valoro es el tiempo que me ahorra. Ya no tengo que adaptar materiales de distintas fuentes." country="Chile" data-id="element-135" />
              <TestimonialCard quote="Necesitaba material para enseñar inglés especializado y encontré exactamente lo que buscaba. Muy recomendable." country="Uruguay" data-id="element-136" />
            </div>
          </FadeIn>
        </section>

        {/* 12. SECOND PRICING (FULL DUPLICATE) */}
      </div>

      <section className="scroll-mt-10" data-id="element-137">
        <FadeIn data-id="element-138">
          <div className="bg-[#1a2744] py-16 px-4" data-id="element-139">
            <div className="max-w-3xl mx-auto text-center" data-id="element-140">
              <h2 className="text-2xl sm:text-3xl font-bold text-brand-pink mb-10" data-id="element-141">
                🔥 Elige el pack que mejor se adapte a ti
              </h2>

              <div className="grid md:grid-cols-3 gap-6 lg:gap-5 max-w-5xl mx-auto items-stretch" data-id="element-142">
                <PlanCard badge="PACK ESP" title="PACK 1 — ENGLISH FOR SPECIFIC PURPOSES (ESP)" items={['Inglés para Adultos', 'English for Travelers', 'Business English Pack 1', 'Business English Pack 2', 'Tourism & Customer Service English', 'Healthcare English', 'International Trade English']} price="USD 19" buttonText="👉 QUIERO EL PACK ESP" href="https://pay.hotmart.com/M106237367A" image="https://cdn.magicpatterns.com/uploads/x4p9a68MANwJ1j7wE5MyRC/PACK_ESP.png" data-id="element-143" />

                <PlanCard badge="PACK TÉCNICO" title="PACK 2 — TECHNICAL ENGLISH" items={['Technical English for Information Technology', 'Technical English for Automotive Technology', 'Technical English for Industrial Automation', 'Technical English for Agricultural Technology']} price="USD 21" buttonText="👉 QUIERO EL PACK TECHNICAL ENGLISH" href="https://pay.hotmart.com/R106308668P" image="https://cdn.magicpatterns.com/uploads/rPiSBQmJwqxZBXpTMMSH3i/PACK_TECNICO.png" data-id="element-144" />

                <PlanCard badge="MEGAPACK COMPLETO" title="" subtitle="Toda la biblioteca profesional y técnica en un solo lugar" items={['Inglés para Adultos', 'English for Travelers', 'Business English Pack 1', 'Business English Pack 2', 'Tourism & Customer Service English', 'Healthcare English', 'International Trade English', 'Technical English for Information Technology', 'Technical English for Automotive Technology', 'Technical English for Industrial Automation', 'Technical English for Agricultural Technology']} originalPrice="USD 40" price="USD 32" savings="¡Ahorrás USD 8!" buttonText="👉 QUIERO TODO EL MATERIAL" href="https://pay.hotmart.com/R106308712C" featured image="https://cdn.magicpatterns.com/uploads/g6MAjRBAsVs3LJqdcgVpM2/MEGAPACK_COMPLETO.png" data-id="element-145" />
              </div>
            </div>
          </div>
        </FadeIn>
      </section>

      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-146">
        {/* 13. GARANTÍA */}
        <section className="text-center py-12 px-4 mb-12" data-id="element-147">
          <FadeIn data-id="element-148">
            <div className="max-w-xl mx-auto" data-id="element-149">
              <img src="https://cdn.magicpatterns.com/uploads/c1WiiD5wweFWiSecTG8bGZ/pasted-image.jpg" alt="Garantía 7 días" className="w-28 h-28 mx-auto mb-4 object-contain" data-id="element-150" />
              <h2 className="text-xl sm:text-2xl font-bold text-brand-navy mb-4" data-id="element-151">
                Garantía de 7 días
              </h2>
              <div className="space-y-3 text-brand-navy" data-id="element-152">
                <p className="font-semibold" data-id="element-153">
                  Queremos que estés 100% conforme con tu compra.
                </p>
                <p data-id="element-154">Pruébalo sin riesgo.</p>
                <p data-id="element-155">
                  Si no te resulta útil, puedes solicitar la devolución dentro
                  de los primeros 7 días.
                </p>
                <p className="font-bold text-brand-pink" data-id="element-156">
                  Tu inversión está protegida.
                </p>
              </div>
            </div>
          </FadeIn>
        </section>

        {/* 14. FAQ */}
        <section className="text-center mb-12" data-id="element-157">
          <FadeIn data-id="element-158">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-navy mb-8" data-id="element-159">
              Preguntas frecuentes
            </h2>

            <div className="space-y-4 max-w-2xl mx-auto text-left" data-id="element-160">
              <FAQItem question="¿El acceso es inmediato?" answer="Sí. Una vez confirmado el pago recibirás acceso automáticamente." data-id="element-161" />
              <FAQItem question="¿Puedo descargar el material?" answer="Sí. Puedes descargarlo y utilizarlo cuando quieras." data-id="element-162" />
              <FAQItem question="¿El acceso tiene vencimiento?" answer="No. El acceso es de por vida." data-id="element-163" />
              <FAQItem question="¿Puedo imprimir las actividades?" answer="Sí. Puedes imprimirlas o utilizarlas digitalmente." data-id="element-164" />
              <FAQItem question="¿Los materiales están organizados?" answer="Sí. Todo el contenido se encuentra organizado por especialidad para facilitar su uso." data-id="element-165" />
            </div>
          </FadeIn>
        </section>

        {/* 15. FINAL CTA */}
        <section className="text-center mb-12" data-id="element-166">
          <FadeIn data-id="element-167">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-pink mb-6" data-id="element-168">
              MEGAPACK TEACHER RESOURCE
            </h2>
            <p className="text-base sm:text-lg text-brand-navy mb-8 max-w-2xl mx-auto" data-id="element-169">
              Todo el material que necesitas para enseñar inglés profesional y
              técnico sin empezar desde cero.
            </p>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto mb-8 text-left" data-id="element-170">
              <ul className="space-y-3" data-id="element-171">
                {['Actividades listas para usar', 'Material organizado', 'Acceso inmediato', 'Descarga digital', 'Acceso de por vida'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-172">
                    <span className="mr-3 text-green-500 text-lg" data-id="element-173">✔</span>
                    {item}
                  </li>)}
              </ul>
            </div>

            <Button onClick={scrollToCompra} data-id="element-174">👉 ACCEDER AHORA</Button>
          </FadeIn>
        </section>
      </div>

      {/* FOOTER */}
      <footer className="bg-black py-8 px-4" data-id="element-175">
        <div className="max-w-3xl mx-auto text-center space-y-4" data-id="element-176">
          <p className="text-white text-sm font-medium" data-id="element-177">
            © 2026 MEGAPACK TEACHER RESOURCE. Todos los derechos reservados.
          </p>
          <p className="text-gray-500 text-xs leading-relaxed max-w-lg mx-auto" data-id="element-178">
            Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}